/* eslint react/no-danger: 'off' */
/* global translations */
import React from 'react';
import get from 'lodash/get';

const VipSubscription = () => (
  <div>
    <div className="tsi mbs">
      {get(translations, 'txt: Iegādājoties VIP abonementu, komplektā iekļauts arī standarta abonements.', '')}
    </div>
    <a
      href="/payments/subscription_vip"
      className="btn btn--g"
      data-target="#content"
    >
      {get(translations, 'txt: Iegādāties VIP abonementu', '')}
    </a>
  </div>
);

export default VipSubscription;
